import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../services/data/data.service';

@Component({
	selector: 'pcm-ui-date-array',
	templateUrl: './ui-date-array.component.html',
	styleUrls: ['./ui-date-array.component.scss']
})
export class UiDateArrayComponent implements OnInit {

	@Input() dates = [];

	dateModel = {};

	constructor(
		private dataService: DataService
	) { }

	ngOnInit() {

	}

	updateDateModel(i) {
		console.log('UPDATE DATE MODEL', this.dateModel[i]);
		this.dates[i] = this.dataService.formatPickerDate(this.dateModel[i]);
		console.log('DATA DATE', this.dates[i]);
	}

	addDate() {
		this.dates.push('');
	}

	removeDate(event, i) {
		this.dates.splice(i, 1);
	}

}
